import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { trackPageView } from "lib/mixpanel";

const PageViewTracker = ({ children, history }) => {
  useEffect(() => {
    trackPageView();

    const unlisten = history.listen(trackPageView);

    return () => {
      unlisten();
    };
  }, [history]);

  return children;
};

export default withRouter(PageViewTracker);
